export const SIGNALR_EVENTS = {
  APPROVAL_REQUESTED: 'ApprovalRequested',
  APPROVAL_DECISION:  'ApprovalDecision',
  APPROVAL_WITHDRAWN: 'ApprovalWithdrawn',
  FORCE_LOGOUT:       'ForceLogout',
};